import { Badge } from '@/components/ui/badge.js';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip.js';

export function GenerationVersionBadge({ version }: { version: number }) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant="outline" tabIndex={0}>
          Version {version}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>
        Version of this generated case set. Requesting changes creates a new
        version; earlier versions remain in the history.
      </TooltipContent>
    </Tooltip>
  );
}
